import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import ProjectDetail from '../../components/project_detail/ProjectDetail';
import { createProject } from '../../redux/projects/projects_actions';

class ProjectCreateModal extends React.Component {
  constructor(props) {
    super(props);
    this.projectDetail = null;

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isCreating !== this.props.isCreating && !nextProps.isCreating) {
      if (nextProps.errorMessage) {

      } else {
        this.props.onHide();
      }
    }
  }

  onSaveHandler() {
    const newProject = this.projectDetail.getWrappedInstance().getWrappedInstance().getProjectData();
    const { location } = newProject;
    this.props.createProject({
      ...newProject,
      latitude: location.lat,
      longitude: location.lng,
    });
  }

  render() {
    const { isCreating, errorMessage, createProject, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-lg">
            {t('create project')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ProjectDetail
            fieldErrors={errorMessage}
            ref={ref => (this.projectDetail = ref)}
            disabled={this.props.isCreating}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            onSubmit={() => !this.props.isCreating && !this.props.isCreated && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="project-submit-create"
            disabled={!isSubmittable || isCreating}
            onClick={() => this.onSaveHandler()}
          >
            {this.props.isCreating ? `${t('creating')}...` : t('create')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  isCreating: state.project.creating,
  errorMessage: state.project.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  createProject: project => dispatch(createProject(project)),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(ProjectCreateModal)
);



// WEBPACK FOOTER //
// ./src/modal/projects/ProjectCreateModal.js